import { BADGE_TYPES } from "./constants";

const getBGColor = (type) => {
   
    switch(type){
        case BADGE_TYPES.GREEN:
        case BADGE_TYPES.SUCCESS:
        case BADGE_TYPES.WAIT:
            return "bg-[#CCFCDA] text-black";
        default:
            return "bg-is2-blue-200 text-is2-blue-100";
    }
}
export function Badge({ content, badgeType }) {
  const bgColor = getBGColor(badgeType);
  return (
    <div
      className={` ${
        bgColor
      }  rounded-md `}
    >
      {content}
    </div>
  );
}
